export default __webpack_public_path__ + "static/transparent-bg-5273cfec2b69e93f606554696d6a6340.png";